# out: $1.js, compress: false, sourcemap: true


$('select[name=district_code]').selectpicker({
      title: 'Ничего не выбрано',
      countSelectedText: '{0} из {1} выбрано'
  });


module = (unit, uses)->

  d = new Date()
  day = d.getDate()
  month = d.getMonth() + 1
  year = d.getFullYear()
  if (day < 10)
    day = Number("0" + day)
  if (month < 10)
    month = Number("0" + month)
  date = day + "." + month + "." + year
  $("#disconnections_filter input[name='date']").val(date)
  yamap = uses.yamap

  map = new yamap.MapControl "#map", {
    mapTools: false,
    routeEditor: false,
    typeSelector: true,
    zoomControl: true,
    smallZoomControl: false,
    scaleLine: true,
    miniMap: false,
    searchControl: false,
    trafficControl: false
  }

  clusterer = new ymaps.Clusterer {
    clusterNumbers: [5, 10]
  }
  map.addObject clusterer
  points = []

  $ ->
    townDependency = ()->
      [{name:"town", value: $("#disconnections_filter input[name=town]").val()}]

    new MultiCombo($("#district_code"), townDependency)


    window.disconnection = {
      onDone: (data)->
        data = $.parseJSON(data)

        $("#disconnections_list tr").not(":first-child()").remove()

        if !data || data.length == 0
          $("#disconnections_list").append(
            """
              <tr>
                <td colspan='4'>
                  Отключений не найдено
                </td>
              </tr>
            """
          )


        for point in points
          clusterer.remove point

        points = []

        for disconnection in data
          pointsJSON = $.parseJSON(disconnection.points)

          disconnection.disconnection_datebegfact = disconnection.disconnection_datebegfact||'';
          disconnection.disconnection_dateendfact = disconnection.disconnection_dateendfact||'';
          disconnection.disconnection_datebegplan = disconnection.disconnection_datebegplan||'';
          disconnection.disconnection_dateendplan = disconnection.disconnection_dateendplan||'';

          datesfact = ''
          bdfl = disconnection.disconnection_datebegfact.trim().length
          edfl = disconnection.disconnection_dateendfact.trim().length
          if ( bdfl == 0 && edfl == 0) || (bdfl > 0 && edfl > 0)
            datesfact = "#{disconnection.disconnection_datebegfact} - #{disconnection.disconnection_dateendfact}"
          else
            datesfact = "#{disconnection.disconnection_datebegfact}#{disconnection.disconnection_dateendfact}"

          datesplan = ''
          bdfl = disconnection.disconnection_datebegplan.trim().length
          edfl = disconnection.disconnection_dateendplan.trim().length
          if ( bdfl == 0 && edfl == 0) || (bdfl > 0 && edfl > 0)
            datesplan = "#{disconnection.disconnection_datebegplan} - #{disconnection.disconnection_dateendplan}"
          else
            datesplan = "#{disconnection.disconnection_datebegplan}#{disconnection.disconnection_dateendplan}"

          disconnection.disconnection_addresses = disconnection.disconnection_addresses.split(/\n+/).join("<br>");

          $("#disconnections_list").append(
            """
              <tr>
                <td class="disables-desc">#{disconnection.disconnection_note}</td>
                <td class="disables-time-off">
                  #{datesplan}
                </td>
                <td class="disables-adres">
                  #{disconnection.disconnection_addresses}
                </td>
                <td class="disables-time-on">
                  #{datesfact}
                </td>
              </tr>
            """
          )

          if pointsJSON
            for point in pointsJSON
              mapPoint = [
                point.lat,
                point.lng
              ]
              obj = map.newMarker mapPoint, {
                hintContent: point.rem
              }
              clusterer.add obj
              points.push obj

        return true
    }

    ready = () =>
      $("#disconnections_filter").submit()

    map.setAddress $("#disconnections_filter input[name=town_name]").val(), ready


unit.define "site::disconnect", module, "std::ajaxform", "yamap", "String"
